import useClipboard from 'vue-clipboard3';
const { toClipboard } = useClipboard();

export default {

    async copy(text){
        return await toClipboard(text);
    }

}
